import { Skeleton } from '@cyphex/ui';

/**
 * The CONTENT area only, for a page loading inside the shell. The rail, the
 * top bar and whatever is live in them (a call, a voice channel, a draft)
 * stay exactly as they are.
 */
export function ContentFallback() {
  return (
    <div className="h-full space-y-4 bg-background p-6" aria-busy="true" aria-label="Loading">
      <Skeleton className="h-8 w-48 rounded-lg" />
      {Array.from({ length: 3 }, (_, i) => (
        <Skeleton key={`card-${i}`} className="h-40 w-full max-w-feed rounded-xl" />
      ))}
    </div>
  );
}

/** Shown while a lazily-loaded route chunk is in flight. Never a blank screen. */
export function RouteFallback() {
  return (
    <div className="flex h-full w-full">
      <div className="hidden w-rail flex-col items-center gap-5 border-r border-border bg-rail py-4 md:flex">
        {Array.from({ length: 8 }, (_, i) => (
          <div key={`rail-${i}`} className="flex flex-col items-center gap-1.5">
            <Skeleton className="h-6 w-6 rounded-md" />
            <Skeleton className="h-2 w-8 rounded-pill" />
          </div>
        ))}
      </div>
      <div className="hidden w-sidebar flex-col gap-3 border-r border-border bg-sidebar p-3 lg:flex">
        <Skeleton className="h-9 w-full rounded-lg" />
        {Array.from({ length: 7 }, (_, i) => (
          <div key={`row-${i}`} className="flex items-center gap-2.5">
            <Skeleton className="h-8 w-8 rounded-md" />
            <div className="flex-1 space-y-1.5">
              <Skeleton className="h-3 w-2/3 rounded-pill" />
              <Skeleton className="h-2.5 w-1/2 rounded-pill" />
            </div>
          </div>
        ))}
      </div>
      <div className="flex-1 space-y-4 bg-background p-6">
        <Skeleton className="h-8 w-48 rounded-lg" />
        {Array.from({ length: 3 }, (_, i) => (
          <Skeleton key={`card-${i}`} className="h-40 w-full max-w-feed rounded-xl" />
        ))}
      </div>
    </div>
  );
}
